// @flow
import {
  Button,
  Input,
  Row,
  Card,
  message,
  Typography,
  Form,
  Space,
  Tag,
  Switch,
} from 'antd';
import * as React from "react";
import { PlusCircleTwoTone } from '@ant-design/icons'
import { useSelector } from "react-redux";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { deleteTask, setIsDoneTask, addTodo } from "../../features/todoRedux/todo";

const TodoList = () => {
  const todos = useSelector((state) => state.todo.todoList);
  console.log(todos);
  return (
    <ul className="tasks-list">
      {todos?.map((todo) => (
        <TodoItem id={todo.id} title={todo.content} completed={todo.isDone} />
      ))}
    </ul>
  );
};

const TodoItem = ({ id, title, isDone }) => {
  const dispatch = useDispatch();
  const [Done, setDone] = useState(false)
  const removeTask = () => {
    dispatch(
      deleteTask({
        id: id,
      })
    );
  };
  const checkDone = () => {
    setDone(true)
    dispatch(
      setIsDoneTask({
        isDone : Done
      })
    )
  }
  console.log(Done);
  return (
    <Row justify="space-between">
      {isDone ? <Tag color="red">{title}</Tag> : <Tag color="green">{title}</Tag>}
      <Space>
        <Switch checkedChildren={Done} unCheckedChildren={!Done} onChange={checkDone}/>
        <Button onClick={removeTask}>delete</Button>
      </Space>
    </Row>
  );
};

export default function Todos() {
  // const Todos = useSelector((state) => state.todo);
  // console.log("asdasdasd",Todos);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [value, setValue] = useState("");
  const onSubmit = (event) => {
    event.preventDefault();

    if (value.trim().length === 0) {
      message.warning("Enter a task before adding !!");
      setValue("");
      return;
    }

    dispatch(
      addTodo({
        todo: value,
      })
    );
    setValue("");
  };


  return (
    <>
      <Row justify="center" align="middle">
        <Card title="Create New Todo" style={{ width: 680 }}>
          <Input placeholder="input placeholder" value={value} onChange={(event) => setValue(event.target.value)} style={{ minWidth: "100vh" }} />
          <Button type="primary" onClick={onSubmit} icon={<PlusCircleTwoTone />}>Add Todo</Button>
        </Card>
      </Row>
      <Row justify='center' align="middle">
        <Card title='Todo List' style={{ width: 680, marginTop: 24 }}>
          <TodoList />
        </Card>
      </Row>
    </>
  );
}
